import { useContext } from 'react'
import PropTypes from 'prop-types'
import ReactModal from 'react-modal'
import styled from '@emotion/styled'
import { Box, Flex } from 'rebass'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { FiX, FiArrowLeft, FiArrowRight } from 'react-icons/fi'
import Arrows from '../atoms/Arrows'
import { Theme } from '../../styles/settings/theme'
import FooterBar from '../atoms/FooterBar'
import { DataContext } from '../../contexts/dataContext'
import { lang } from '../../utils/lang'
import { BASE_URL } from '../../utils/constants'

const StyledFlex = styled(Flex)`
  position: absolute;
  top: 0.5rem;
  right: ${(props) => (props.ui === 'en' ? '0.5rem' : 'unset')};
  left: ${(props) => (props.ui === 'en' ? 'unset' : '0.5rem')};
  cursor: pointer;
`
const Bar = styled(Flex)`
  width: 100%;
  height: 3rem;
  position: sticky;
  bottom: 0;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.colors.aqua};
  font-family: ${(props) => props.theme.fonts.condensed};
  font-weight: 700;
  font-size: 1rem;
  text-transform: uppercase;
  a {
    color: ${(props) => props.theme.colors.steelBlue};
    &:hover {
      color: ${(props) => props.theme.colors.white};
      text-decoration: none;
    }
    &:visited {
      text-decoration: none;
    }
  }
`

const ModalContainer = ({
  children,
  hideModal,
  personId,
  setPersonId,
  list,
  nonFatalCase,
  handleNonFatalCase
}) => {
  const { ui } = useContext(DataContext)
  const dir = ui === 'en' ? 'ltr' : 'rtl'
  const handleId = () => {
    hideModal()
    setPersonId(null)
    handleNonFatalCase(null)
  }
  const backToList = () => {
    setPersonId(null)
  }
  const matches = useMediaQuery('(min-width:500px)')
  const customStyles = {
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      zIndex: 1100
    },
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      padding: '0',
      maxHeight: matches ? '78vh' : '100vh',
      overflow: 'auto',
      width: '100%',
      maxWidth: '60rem',
      transform: 'translate(-50%, -50%)',
      backgroundColor:
        matches || list ? Theme.colors.steelBlue : Theme.colors.ironBlue, //list prop lets it be lighter blue for list on mobile
      border: 'none'
    }
  }

  const uiLang = ui === 'fa' ? 'fa/' : ''

  return (
    <ReactModal isOpen style={customStyles}>
      <StyledFlex ui={ui} dir={dir}>
        <Box p={ui === 'en' ? '0 .75rem 0 0' : '0 0 0 .75rem'}>
          {list && personId && ui === 'en' && (
            <FiArrowLeft
              color={Theme.colors.white}
              size="30"
              onClick={backToList}
            />
          )}
          {list && personId && ui === 'fa' && (
            <FiArrowRight
              color={Theme.colors.white}
              size="30"
              onClick={backToList}
            />
          )}
        </Box>
        <FiX color={Theme.colors.white} size="30" onClick={handleId} />
      </StyledFlex>
      {children}
      {/* only want to see 'read more' footer bar in fatal cases */}
      {personId && !nonFatalCase && (
        <Bar dir={dir}>
          <a
            href={`${BASE_URL}/${uiLang}memorial/story/${personId}`}
            target="_blank"
            rel="noreferrer"
          >
            {lang[ui]['Read']}/{lang[ui]['Complete']}
          </a>
          <Box pl={ui === 'en' ? 2 : 0} pr={ui === 'en' ? 0 : 2} pt={'2px'}>
            <Arrows
              color={Theme.colors.steelBlue}
              width=".75rem"
              height=".75rem"
              flip={ui === 'fa'}
            />
          </Box>
        </Bar>
      )}

      <FooterBar modal={true} />
    </ReactModal>
  )
}
export default ModalContainer

ModalContainer.propTypes = {
  children: PropTypes.element.isRequired,
  hideModal: PropTypes.func.isRequired,
  personId: PropTypes.number,
  setPersonId: PropTypes.func,
  list: PropTypes.bool
}
